"use client"

import useToggleState from "@lib/hooks/use-toggle-state"
import { ExtendedStoreCart } from "types/global"
import CartDrawer from "../cart-drawer"
import CartButtonTemplate from "./cart-button-template"

type Props = {
  cart: ExtendedStoreCart | null
}

export default function CartButton({ cart }: Props) {
  const { state, close, toggle } = useToggleState()

  const totalItems =
    cart?.items?.reduce((acc, item) => {
      return acc + item.quantity
    }, 0) || 0

  return (
    <>
      <div className="h-full flex items-center cursor-pointer" onClick={toggle}>
        <CartButtonTemplate totalItems={totalItems} />
      </div>
      <CartDrawer cart={cart} isOpen={state} onClose={close} />
    </>
  )
}
